module.exports = __webpack_public_path__ + "img/skateboard.ec6aced.png";